module.exports = __webpack_public_path__ + "img/i-community-content-admin.89805fae.svg";